module.exports = __webpack_public_path__ + "img/CE认证.99d21fa3.svg";